import { Pais } from '../despacho/Pais';

export class Provincia {
    id: string;
    nombre: string;
    codigo: string;
    pais: Pais;
}